import { render, staticRenderFns } from "./WhatsappMessageView.vue?vue&type=template&id=33cc09e4"
import script from "./WhatsappMessageView.vue?vue&type=script&lang=js"
export * from "./WhatsappMessageView.vue?vue&type=script&lang=js"
import style0 from "./WhatsappMessageView.vue?vue&type=style&index=0&id=33cc09e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports